import _this from '../main'
const baseUrl = window.baseUrlList[0]
const utils = {
  /**
   * @Description: 默认图片
   * @date 2023/9/7
   * @return
   */
  errorAvatar (event){
    event.currentTarget.src = require("@/assets/img/photo/default_user_img.png");
    return true;
  },
  /**
   * @Description: 默认图片
   * @date 2023/9/7
   * @return
   */
  errorArtImg (event){
    event.currentTarget.src = require("@/assets/img/common/imgError.svg");
    return true;
  },
  /**
   * @Description: 默认拍卖图片
   * @date 2023/9/7
   * @return
   */
  errorArtAuction (event){
    event.currentTarget.src = require("@/assets/img/common/paimai.svg");
    return true;
  },
  /**
   * @Description: 默认拍卖图片
   * @date 2023/9/7
   * @return
   */
  errorArtAuction1 (event){
    event.currentTarget.src = require("@/assets/img/common/paimai1.svg");
    return true;
  },
  /**
   * @Description: //获取到视频的高度,宽度,第一帧的数据
   * @author fen
   * @date 2023/5/11
   * @return
   * @param file
   */
  getVideoMsg(file) {
    let isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    return new Promise((resolve) => {
      let videoElement = document.createElement("video");
      let canvasElement = document.createElement("canvas");
      const ctx = canvasElement.getContext('2d'); // 绘制2d
      videoElement.src = URL.createObjectURL(file);
 	    videoElement.crossOrigin = 'anonymous';
      videoElement.currentTime = 1;

      // 移动端是手动触发播放
      if (isIOS) {
        // 提示视频的元数据已加载
        videoElement.addEventListener("loadedmetadata", function () {
          canvasElement.width = videoElement.videoWidth;
          canvasElement.height = videoElement.videoHeight;
          ctx.drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight);
          const base64 = canvasElement.toDataURL("image/jpeg").split(',')[1];
          resolve({
            width: videoElement.videoWidth,
            height: videoElement.videoHeight,
            cover_file_base64: base64
          });
        });
      }
      else {
        let metaData = {};
        // 提示视频的元数据已加载
        videoElement.addEventListener("loadedmetadata", function () {
          canvasElement.width = videoElement.videoWidth;
          canvasElement.height = videoElement.videoHeight;
          metaData = {
            width: videoElement.videoWidth,
            height: videoElement.videoHeight,
          };
        });

        // 提示该视频已准备好开始播放
        videoElement.addEventListener("canplay", function () {
          ctx.drawImage(videoElement, 0, 0, metaData.width, metaData.height);
          const base64 = canvasElement.toDataURL("image/jpeg").split(',')[1];
          resolve({
            ...metaData,
            cover_file_base64: base64
          });
        });
      }
    });
  },
  /**
   * @Description: 是否是video
   * @author fen
   * @date 2023/5/10
   * @return
   * @param type
   */
  isVideo (type) {
    return type && type.length && type.indexOf('video') > -1
  },
  /**
   * 千分位相关
   * */
  comdify (n) {
    if(!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
  },
  /**
   * 去除千分位中的‘，’
   * */
  delcommafy (num){
    if(!num) return num;
    num = num.toString();
    num = num.replace(/,/gi, '');
    return num;
  },
  /**
  * 格式化数字 千分位
  * */
  formatNum (num, i) {
    let newNum = Number(num) || 0
    let resNum = String(newNum.toFixed(2));
    let b = resNum.split(".");
    let x = b[0];
    let y = b[1] || '00';
    return x.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + y
  },
  /**
   * 递归方法处理空数组
   * */
  getTreeData (data, params) {
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        if (item[params] && item[params].length) {
          this.getTreeData(item[params], params)
        } else {
          item[params] = undefined
        }
      }
      return data
    }
  },
  /**
   * 导出单个文件
   * */
  handleExport (id) {
    window.open(`${baseUrl}/file/downloadFile/${id}`)
  },
  /**
   * 导出批量文件
   * */
  handleBatchExport (ids, filename) {
    let url = `${baseUrl}/file/batchDownloadFile?ids=${ids}`
    let request = new XMLHttpRequest()
    request.open('get', url)
    request.setRequestHeader('Content-type', 'application/json;charset=utf-8') // 必须写在open和send中间
    // 报表导出携带的token
    request.setRequestHeader('x-auth-token', window.localStorage.getItem('art-x-auth-token'))
    request.responseType = 'blob'
    request.onreadystatechange = function (e) {
      if (this.readyState === 4 && this.status === 200) {
        let binStr = this.response
        let blob = new Blob([binStr])
        let downloadElement = document.createElement('a')
        downloadElement.href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.download = filename + '.zip'
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元
        window.URL.revokeObjectURL(downloadElement) // 释放掉blob对象
      }
    }
    request.send()
  },
  /**
   * @Description: 显示视频、图片
   * @author fen
   * @date 2023/5/11
   * @param item
   * @return
  */
  formatFileId (item) {
    return item.is_video === '1' ? item.cover_file_id : item.zip_file_id || item.file_id;
  },
  /**
  * 格式化数据显示
  * */
  formatArtText (num, unit, data1, data2, data3) {
    if (num === 1) {
      return data1 ? `${data1} ${unit}` : '--'
    }
    if (num === 2) {
      return (data1 && data2) ? `${data1} x ${data2} ${unit}` : '--'
    }
    if (num === 3) {
      return (data1 && data2 && data3) ? `${data1} x ${data2} x ${data3} ${unit}` : '--'
    }
  },
  // 处理时间，value传时间戳，type传时间格式：例如'yyyy-MM-dd hh:mm:ss'
  handleTimeFormat (value, type) {
    if (!value) return '--'
    let date = new Date(value)
    let params = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(type)) {
      type = type.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let key in params) {
      if (new RegExp('(' + key + ')').test(type)) {
        type = type.replace(RegExp.$1, (RegExp.$1.length === 1) ? (params[key]) : (('00' + params[key]).substr(('' + params[key]).length)))
      }
    }
    return type
  },
  transformCharCode (code) {
    return String.fromCharCode(code)
  },
  // 取到小数点后两位
  numberToFix2 (number) {
    let num = number.toString()
    if (num.indexOf('.') > -1) {
      return parseFloat(num.substr(0, num.indexOf('.') + 3)).toFixed(2)
    } else {
      return parseFloat(num).toFixed(2)
    }
  },
  // i18n切换语言
  setAPPLanguage (language, cb) {
    _this.loadLanguageAsync(language).then((res) => {
      if (typeof res === 'object') {
        utils.setAPPLanguage('zh-cn', cb)
      } else {
        _this.$store.commit('global/SET_LANG_I18n', language)
        localStorage.setItem('art-i18n_language', language)
        cb && cb()
      }
    })
  },
  // 防抖函数
  debounce (func, wait) {
    var timeout
    return function () {
      var context = this
      var args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait)
    }
  },
  dateFormatToYMD (date) {
    if (!date) {
      return '--'
    }
    let Dates = new Date(date)
    let Y = Dates.getFullYear()
    let M = Dates.getMonth() + 1
    let D = Dates.getDate()
    let times = Y + (M < 10 ? '.0' : '.') + M + (D < 10 ? '.0' : '.') + D
    return times
  },

  filterList (list, i) {
    return list.filter((item, index) => index % 3 === i)
  },

  compatibleMobilePage: [
    null,
    '',
    'home',
    'artworkArchive',
    'devOpsManage',
    'login',
    'loginFail',
    'page404',
    'artworkArchive_index',
    'artworkArchive_detail',
    'devOpsManage/index',
    'artworkArchiveSummary',
    'financeManageSummary',
    'warehouseSummary',
    'dynamicManage',
    'dynamicManageTable',
    'dynamicManageExhibition',
    'dynamicManageMessage',
    'valueManage',
    'devOpsLinkPage',
    'artworkArchive_add',
    'devOpsHistory',
    'mochaItom',
    'batchDetail',
    'devOpsStoreHouse',
    'devOpsInsurance',
    'resumeInsurance',
    'createAnnualInsurance',
    'payoutInsurance',
    'createPayoutInsurance',
    'createOperateInsurance',
    'devOpsValueManage',
    'devOpsTransport',
    'historyInsurance',
    'transportHistory',
  ],

  setRem () {
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    let htmlDom = document.getElementsByTagName('html')[0];
    let bodyDom = document.getElementsByTagName('body')[0]

    console.log(_this.$route.name)

    let scale = 1.7 // 三星手机的倍数
    let small_page = utils.compatibleMobilePage
    let small_scale_html = small_page.includes(_this.$route.name) ? (14.4 / scale) : 14.4
    let small_scale_body = small_page.includes(_this.$route.name) ? `${12 * scale}px` :'12px'

    htmlDom.style.fontSize = htmlWidth <= 1440 ?
      (htmlWidth <= 991 ?
        ((htmlWidth / small_scale_html) + 'px')
        : htmlWidth/14.4 + 'px')
      : 1440/14.4 + 'px';
    bodyDom.style.fontSize = htmlWidth <= 1440 ?
      (htmlWidth <= 991 ?
        small_scale_body
        : '12px')
      : '16px'

    _this.$store.dispatch('global/set_hidden_sm_and_down', htmlWidth <= 991 && small_page.includes(_this.$route.name))

    if (!htmlDom.style.fontSize || htmlDom.style.fontSize === '') {
      console.log(htmlWidth, htmlDom.style.fontSize, bodyDom)
      utils.setRem()
    }
  },

  stepsInfo (event_type) {
    let stepsData = []
    if (event_type === 'BUY_ART') { // 尽调报告
      stepsData.push(
        { name: '尽调报告', icon: require(`@/assets/img/common/process/jindiaobaogao2.svg`)},
				{ name: '合同签订', icon: require(`@/assets/img/common/process/hetongqianding2.svg`) },
        { name: '付款流程', icon: require(`@/assets/img/common/process/fukuanliucheng2.svg`) }
      )
    } else if (event_type === 'BUY_ART_TRANS') { // 购买运输
      stepsData.push(
        { name: '运输', icon: require(`@/assets/img/common/process/yunshu2.svg`)},
				{ name: '入库', icon: require(`@/assets/img/common/process/ruku2.svg`) }
      )
    } else if (event_type === 'OPERATION_TRANS_ART') { // 运输
      stepsData.push(
        { name: '运输信息', icon: require(`@/assets/img/common/info.svg`)},
				{ name: '运输', icon: require(`@/assets/img/common/transport.svg`) }
      )
    }
    else if (event_type === 'OPERATION_SHOT_ART') { // 拍摄
      stepsData.push(
        { name: '拍摄信息', icon: require(`@/assets/img/common/process/xinxi2.svg`)},
				{ name: '拍摄', icon: require(`@/assets/img/common/process/paishe2.svg`) },
        { name: '成品交付', icon: require(`@/assets/img/common/process/chengpinjiaofu2.svg`) }
      )
    }
    // 装裱
    else if (event_type === 'OPERATION_MOUNT_ART') {
      stepsData.push(
        {name: '装裱信息', icon: require(`@/assets/img/common/process/xinxi2.svg`)},
        {name: '藏品运输', icon: require(`@/assets/img/common/transport.svg`)},
        {name: '成品交付', icon: require(`@/assets/img/common/process/chengpinjiaofu2.svg`)}
      )
    }
    // 修复
    else if (event_type === 'OPERATION_REPAIR_ART') {
      stepsData.push(
        {name: '修复信息', icon: require(`@/assets/img/common/process/xinxi2.svg`)},
        {name: '藏品运输', icon: require(`@/assets/img/common/transport.svg`)},
        {name: '成品交付', icon: require(`@/assets/img/common/process/chengpinjiaofu2.svg`)}
      )
    }
    // 借展
    else if (event_type === 'OPERATION_LOAN_EXHIBITION_ART') {
      stepsData.push(
        {name: '藏品借展', icon: require(`@/assets/img/common/process/xinxi2.svg`)},
        {name: '藏品运输', icon: require(`@/assets/img/common/transport.svg`)},
      )
    }
    // 出售
    else if (event_type === 'OPERATION_SELL_ART') {
      stepsData.push(
        {name: '市场调查报告', icon: require(`@/assets/img/common/process/jindiaobaogao2.svg`)},
        {name: '合同签订', icon: require(`@/assets/img/common/process/hetongqianding2.svg`)},
        {name: '收款流程', icon: require(`@/assets/img/common/process/fukuanliucheng2.svg`)},
      )
    }
    else if (event_type === 'OPERATION_REPLICA_ART') { // 复制
      stepsData.push(
        { name: '复制信息', icon: require(`@/assets/img/common/process/xinxi2.svg`)},
				{ name: '复制', icon: require(`@/assets/img/common/process/fuzhi2.svg`) },
        { name: '成品交付', icon: require(`@/assets/img/common/process/chengpinjiaofu2.png`) }
      )
    }
    return stepsData;

  },
  /**
   * @Description: 排序
   * @date 2023/9/12
   */
  handleSortMethod (a, b, key) {
    let res = 0;
    let aVal = a[key]
    let bVal = b[key]

    for (let i = 0; ;i++) {
      if (!aVal[i] || !bVal[i]) {
        res = aVal.length - bVal.length;
        break;
      }
      let char1 = aVal[i];
      let char1Type = this.getChartType(char1);
      let char2 = bVal[i];
      let char2Type = this.getChartType(char2);

      // 类型相同的逐个比较字符
      if (char1Type[0] === char2Type[0]) {
        // console.log('字符类型相同');
        if (char1 === char2) {
          res = 0;
          // console.log('值全等', res);
          continue;
        } else {
          if (char1Type[0] === 'zh') {
            res = char1.localeCompare(char2, 'zh-cn');
            // console.log('a的字符类型为中文', res);
          } else if (char1Type[0] === 'en') {
            res = char1.charCodeAt(0) - char2.charCodeAt(0);
            // console.log('a的字符类型为英文', res);
          } else {
            res = char1 - char2;
            // console.log('a的字符类型为数字', res);
          }
          // console.log('值不相等比较的结果', res);
          break;
        }
      } else {
        // 类型不同的，直接用返回的数字相减
        let num1 = char1Type[1];
        let num2 = char2Type[1];
        res = num1 - num2;
        break;
      }
    }
    return res;
  },
  /**
   * @Description: 数字可按照排序的要求进行自定义 ;数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
   * @date 2023/9/12
   */
  getChartType(char) {
    if (/^[\u4e00-\u9fa5]+$/.test(char)) {
      return ['zh', 3];
    }
    if (/^[a-zA-Z]$/.test(char)) {
      return ['en', 2];
    }
    if (/^[0-9]$/.test(char)) {
      return ['number', 1];
    }
    return ['others', 4];
  },

}

// 低版本浏览器nodeList不支持forEach的兼容处理
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

/**
 * @Description: el-select在移动端/ipad上搜索功能不能弹出软键盘进行搜索的问题
 * @date 2023/9/25
 */
Array.from(document.getElementsByClassName('el-select')).forEach((item) => {
  item.children[0].children[0].removeAttribute('readOnly')
  item.children[0].children[0].onblur = function () {
    let _this = this
    setTimeout(() => {
      _this.removeAttribute('readOnly')
    }, 200)
  }
})

export default utils



// WEBPACK FOOTER //
// ./src/global/utils.js